import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import makeStyles from "@mui/styles/makeStyles";

import { ROOT } from "../../consts/routes";

import { getUserMetadata } from "../../reducers/ownUser/selectors";
import { resetDriverManagement } from "../../reducers/driverManagement/thunkActions";
import { resetMatrix } from "../../reducers/matrixProfile/thunkActions";
import { resetDepot } from "../../reducers/depot/thunkActions";
import { resetMapState } from "../../reducers/map";
import { resetSectionManagement } from "../../reducers/sectionManagement/thunkActions";
import { resetRouteManagement } from "../../reducers/routeManagement/thunkActions";
import { resetShiftManagerManagement } from "../../reducers/shiftManagerManagement/thunkActions";
import { resetAppState } from "../../reducers/ownApp";
import { resetUser } from "../../reducers/ownUser/";
import { fetchUserMetadata } from "../../reducers/ownUser/thunkActions";

import { View } from "../../components/View";
import LoadingOverlay from "../../components/LoadingOverlay";

const useStyles = makeStyles({
  container: {
    display: "flex",
    height: "100%",
    width: "100vw",
  },
});

export const UserPageHOC = ({ PageComponent, requiredRole = null }) => {
  const styles = useStyles();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const userMetadata = useSelector(getUserMetadata);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) {
      dispatch(resetShiftManagerManagement());
      dispatch(resetRouteManagement());
      dispatch(resetSectionManagement());
      dispatch(resetDriverManagement());
      dispatch(resetMatrix());
      dispatch(resetDepot());
      dispatch(resetMapState());
      dispatch(resetAppState());
      dispatch(resetUser());
    } else if (!userMetadata) dispatch(fetchUserMetadata());
    else if (requiredRole && !userMetadata.roles.includes(requiredRole))
      navigate(ROOT);
  }, [dispatch, user, userMetadata, requiredRole, navigate]);

  return (
    <View className={styles.container}>
      {!userMetadata ? <LoadingOverlay /> : null}
      <PageComponent />
    </View>
  );
};
